import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const SAVED_DASHBOARDS_QUERY_KEY = ["saved-dashboards"] as const;

type SavedDashboardSortKey = components["schemas"]["SavedDashboardSortKey"];
type SortOrder = components["schemas"]["SortOrder"];

export type ListSavedDashboardsQuery = {
  include_deleted?: boolean;
  sort_key?: SavedDashboardSortKey;
  sort_order?: SortOrder;
  limit?: number;
  offset?: number;
};

export function useSavedDashboards(params: ListSavedDashboardsQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...SAVED_DASHBOARDS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/saved-dashboards", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list saved dashboards");
      }
      return data;
    },
  });
}
